import {
  GET_RESERVATIONLIST,
  GET_ADDRESERVATION,
  GET_UPDATERESERVATION,
  GET_RESERVATIONDETAILS,
  GET_BOOKINGREPORTDOWNLOAD,
  GET_CANCELCHARGES,
  GET_CANCELREASON,
  GET_BOOKINGBUFFERTIME,
  GET_AIRPORTTERMINALLIST,
  GET_NOTIFICATIONRECIPIENTS,
  SEND_NOTIFICATIONS,
  MARK_TRIP_NO_SHOW,
  EDIT_DUTY_SLIP,
  GET_ALL_CITIES,
  GET_RATE_CARDS_V2,
  GET_RATE_ESTIMATE,
  CANCEL_PAYMENT_LINK,
  GET_TOLL_CHARGES,
  ADD_TOLL_CHARGE,
  UPDATE_TOLL_CHARGE,
  DELETE_TOLL_CHARGE,
} from "resources/actionTypes";

export function getReservationList(reservationData) {
  return {
    type: GET_RESERVATIONLIST.GET_RESERVATIONLIST_REQUESTED,
    payload: reservationData,
  };
}

export function getReservationDetails(reservationPayload) {
  return {
    type: GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_REQUESTED,
    payload: reservationPayload,
  };
}

export function clearReservationDetails() {
  return {
    type: GET_RESERVATIONDETAILS.CLEAR_RESERVATIONDETAILS,
  };
}

export function postAddReservation(reservationData, toggle) {
  const data = {
    reservationData: reservationData,
    setConfirmModal: toggle,
  };
  return {
    type: GET_ADDRESERVATION.GET_ADDRESERVATION_REQUESTED,
    payload: data,
  };
}

export function patchupdateReservation(updateReservationData, pageType, id) {
  const data = {
    updateReservationData: updateReservationData,
    navigate: pageType,
    id: id,
  };

  return {
    type: GET_UPDATERESERVATION.GET_UPDATERESERVATION_REQUESTED,
    payload: data,
  };
}

// Download Report
export function getDownLoadList(downloadData) {
  return {
    type: GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_REQUESTED,
    payload: downloadData,
  };
}

export function getCancelReason(cancelReasonData) {
  return {
    type: GET_CANCELREASON.GET_CANCELREASON_REQUESTED,
    payload: cancelReasonData,
  };
}

export function getBookingBufferTime(payloadData) {
  return {
    type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED,
    payload: payloadData,
  };
}

export function getAirportTerminalList(payloadData) {
  return {
    type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED,
    payload: payloadData,
  };
}

// export function getNotificationRecipients(tripId) {
//   return {
//     type: GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_REQUESTED,
//     payload: tripId,
//   };
// }

export function getNotificationRecipients(tripId, notificationType) {
  return {
    type: GET_NOTIFICATIONRECIPIENTS.GET_NOTIFICATIONRECIPIENTS_REQUESTED,
    payload: { tripId, notificationType },
  };
}

export function clearNotificationRecipients() {
  return {
    type: GET_NOTIFICATIONRECIPIENTS.CLEAR_NOTIFICATIONRECIPIENTS,
  };
}

// export function sendNotifications(tripId, selectedRecipientKeys, onSuccess) {
//   const data = {
//     tripId,
//     payload: { selectedRecipientKeys },
//     onSuccess,
//   };
//   return {
//     type: SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_REQUESTED,
//     payload: data,
//   };
// }

export function sendNotifications(
  tripId,
  notificationType,
  selectedRecipientKeys,
  onSuccess,
) {
  const data = {
    tripId,
    payload: { notificationType, selectedRecipientKeys },
    onSuccess,
  };
  return {
    type: SEND_NOTIFICATIONS.SEND_NOTIFICATIONS_REQUESTED,
    payload: data,
  };
}

export function markTripAsNoShow(noShowData, pageType, toggleModal) {
  const data = {
    noShowData: noShowData,
    pageType: pageType,
    setModal: toggleModal,
  };

  return {
    type: MARK_TRIP_NO_SHOW.MARK_TRIP_NO_SHOW_REQUEST,
    payload: data,
  };
}

export function clearSendNotifications() {
  return {
    type: SEND_NOTIFICATIONS.CLEAR_SEND_NOTIFICATIONS,
  };
}

export function editDutySlip(editData, tripId, toggleModal) {
  const data = {
    editData: editData,
    tripId: tripId,
    setModal: toggleModal,
  };

  return {
    type: EDIT_DUTY_SLIP.EDIT_DUTY_SLIP_REQUEST,
    payload: data,
  };
}

export function getAllCities(allCities = true) {
  return {
    type: GET_ALL_CITIES.GET_ALL_CITIES_REQUESTED,
    payload: allCities,
  };
}

export function clearAllCities() {
  return { type: GET_ALL_CITIES.CLEAR_ALL_CITIES };
}

export function getRateCardsV2(payload) {
  return {
    type: GET_RATE_CARDS_V2.GET_RATE_CARDS_V2_REQUESTED,
    payload,
  };
}

export function clearRateCardsV2() {
  return { type: GET_RATE_CARDS_V2.CLEAR_RATE_CARDS_V2 };
}

export function getRateEstimate(payload) {
  return {
    type: GET_RATE_ESTIMATE.GET_RATE_ESTIMATE_REQUESTED,
    payload,
  };
}

export function clearRateEstimate() {
  return { type: GET_RATE_ESTIMATE.CLEAR_RATE_ESTIMATE };
}
export function cancelPaymentLink(data, onSuccess) {
  return {
    type: CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_REQUEST,
    payload: { ...data, onSuccess },
  };
}

export function getTollCharges(params) {
  return {
    type: GET_TOLL_CHARGES.GET_TOLL_CHARGES_REQUESTED,
    payload: params,
  };
}

export function addTollCharge(payload, onSuccess, onError) {
  return {
    type: ADD_TOLL_CHARGE.ADD_TOLL_CHARGE_REQUESTED,
    payload: { payload, onSuccess, onError },
  };
}

export function updateTollCharge(id, payload, onSuccess, onError) {
  return {
    type: UPDATE_TOLL_CHARGE.UPDATE_TOLL_CHARGE_REQUESTED,
    payload: { id, payload, onSuccess, onError },
  };
}

export function deleteTollCharge(id, onSuccess, onError) {
  return {
    type: DELETE_TOLL_CHARGE.DELETE_TOLL_CHARGE_REQUESTED,
    payload: { id, onSuccess, onError },
  };
}
